"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SskyChips = void 0;

const Edit_1 = __importDefault(require("@mui/icons-material/Edit"));

const material_1 = require("@mui/material");

const memoize_one_1 = __importDefault(require("memoize-one"));

const react_1 = __importDefault(require("react"));

const SskyTooltip_1 = __importDefault(require("../SskyTooltip"));

const StyledChip = (0, material_1.styled)(material_1.Chip, {
  shouldForwardProp: prop => prop !== "warning"
})(({
  warning
}) => ({
  [`&.${material_1.chipClasses.root}`]: {
    "&:not(:last-child)": {
      marginRight: "10px"
    }
  },
  [`&.${material_1.chipClasses.deletable}`]: Object.assign({
    "&:focus": {
      backgroundColor: "#e0e0e0"
    }
  }, warning ? {
    backgroundColor: "#FFE5E5",
    '&:focus': {
      backgroundColor: "#FFC0C0"
    },
    '&:hover': {
      backgroundColor: "#FFC0C0"
    },
    '&:active': {
      backgroundColor: "#FFC0C0"
    }
  } : {}),
  [`& .${material_1.chipClasses.deleteIcon}`]: warning ? {
    color: "#FF3333",
    '&:hover': {
      color: "#B63030"
    }
  } : {}
}));
const StyledEditableLabel = (0, material_1.styled)("span")({
  display: "flex",
  alignItems: "center"
});
const StyledEditIcon = (0, material_1.styled)(Edit_1.default)({
  color: "rgba(0, 0, 0, 0.4)",
  cursor: "pointer",
  height: "20px",
  marginLeft: "2px",
  opacity: 0,
  '&:hover': {
    opacity: 1
  }
});

const SskyChips = props => {
  const handleDeleteChip = (chip, index, e) => {
    if (props.handleDeleteChip) {
      props.handleDeleteChip(chip, index, e);
    }
  };

  const handleEditChip = (chip, index, e) => {
    if (props.handleEditChip) {
      props.handleEditChip(chip, index, e);
    }
  };

  const getChips = (0, memoize_one_1.default)(chips => {
    return chips.map((chip, index) => {
      var _a, _b, _c, _d, _e, _f;

      return react_1.default.createElement(SskyTooltip_1.default, {
        key: index,
        placement: chip.tooltipPlacement,
        title: chip.tooltipText ? chip.tooltipText : "",
        dataTestId: chip.tooltipText ? `warning-chip-tooltip-${chip.label}` : ""
      }, react_1.default.createElement(StyledChip, {
        key: index,
        className: `${(_a = props.classes) === null || _a === void 0 ? void 0 : _a.root} ${chip.warning ? (_b = props.classes) === null || _b === void 0 ? void 0 : _b.rootWarning : ""}`,
        classes: {
          deleteIcon: chip.warning ? (_c = props.classes) === null || _c === void 0 ? void 0 : _c.deleteIcon : "",
          deletable: (_d = props.classes) === null || _d === void 0 ? void 0 : _d.deletable
        },
        warning: chip.warning,
        label: chip.editable ? react_1.default.createElement(StyledEditableLabel, {
          className: (_e = props.classes) === null || _e === void 0 ? void 0 : _e.editableSpanLabel
        }, chip.label, " ", react_1.default.createElement(StyledEditIcon, {
          className: (_f = props.classes) === null || _f === void 0 ? void 0 : _f.editableChipEditIcon,
          onClick: e => handleEditChip(chip, index, e)
        })) : chip.label,
        onDelete: chip.hideDeleteBtn ? undefined : e => handleDeleteChip(chip, index, e),
        avatar: chip.avatar ? react_1.default.createElement(material_1.Avatar, null, chip.avatar) : undefined,
        icon: chip.icon,
        "data-testid": chip.chipDataTestId || `testId-${chip.label}`,
        clickable: !chip.nonClickable,
        deleteIcon: chip.deleteIcon,
        onClick: chip.nonClickable ? undefined : chip.onClick,
        size: chip.chipSize
      }));
    });
  });
  return react_1.default.createElement("div", {
    className: props.className,
    "data-testid": props.dataTestId
  }, getChips(props.chipData));
};

exports.SskyChips = SskyChips;
exports.default = react_1.default.memo(SskyChips);